import { render, staticRenderFns } from "./ProxyMigrateCDP.vue?vue&type=template&id=12702a7a&scoped=true&"
import script from "./ProxyMigrateCDP.vue?vue&type=script&lang=js&"
export * from "./ProxyMigrateCDP.vue?vue&type=script&lang=js&"
import style0 from "./ProxyMigrateCDP.vue?vue&type=style&index=0&id=12702a7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12702a7a",
  null
  
)

export default component.exports